/* RESPONSIBLE TEAM: team-inbox-management */
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { inject as service } from '@ember/service';
import type ThemeService from 'embercom/services/theme-service';

export default class InboxRoute extends Route {
  @service declare router: RouterService;
  @service declare themeService: ThemeService;

  analytics = {
    place: 'inbox',
  };
}
